import React from "react";
import { NEBRASKA_CONSTS, ILS_CONSTS, DataValidation } from "../../../Utils/StaticData/Constant";
import { Text } from "react-internationalization";
import { FieldLabel } from "../../translations/dynamic";
const NeBraskaWithdrawl_Fields = [
  {
    name: "acctholdername",
    id: "acctholdername",
    label: <Text id="premium.accountholdername" />,
    text: "",
    len: 40,
  },
  {
    name: "bankName",
    id: "bankName",
    label: <Text id="premium.bankname" />,
    text: "",
    len: 20,
  },
  {
    name: "routingNumber",
    id: "routingNumber",
    label: <Text id="premium.bankroutingnum" />,
    text: <Text id="premium.bankroutingnumtext" />,
    len: 9,
  },
  {
    name: "accountNumber",
    id: "accountNumber",
    label: <Text id="premium.bankaccountnum" />,
    text: <Text id="premium.bankaccountnumtext" />,
    len: 17,
  },
];
const NeBraska_AccType = [
  {
    name: "acctType",
    id: "accountType_C",
    label:<Text id="premium.bankaccounttype1" />,
    value: "CHECKING",
  },
  {
    name: "acctType",
    id: "accountType_S",
    label: <Text id="premium.bankaccounttype2" />,
    value: "SAVING",
  },
];
const requiredFields=(customerId1)=>{
  //some fields are not required for some customers so this fuction written to filter the required fields
  let fieldsRequired;
  switch (customerId1) {
    case NEBRASKA_CONSTS.ID:{
      fieldsRequired=["acctholdername","routingNumber","accountNumber"]
      break;
    }
    case ILS_CONSTS.ID:{
      fieldsRequired=["acctholdername","bankName","routingNumber","accountNumber"]
      break;
    }
    default:{
      fieldsRequired=["acctholdername","bankname","routingNumber","accountNumber"]
      break;
    }
  }
  return fieldsRequired;
}
const NeBraskaPremiums = (isPreview, data, handleChange,customerId) => {
  let premiums = [
    {
      type: "radio",
      name: "premiumType",
      id: "withdrawal",
      value: "W",
      label: FieldLabel("withDrawl",customerId),
    },
  ];
let listOfFields=React.useMemo(()=>requiredFields(customerId),[])
  return (
    <>
      {isPreview
        ? data.premiumType
          ? (premiums ?? []).map((pre) => (
              <div class="custom-control custom-radio custom-control-inline mt-1 pe-none">
                <input
                  type={pre?.type}
                  name={pre?.name}
                  id={pre?.id}
                  class="custom-control-input"
                  value={pre?.value}
                  checked={data[pre?.name] === pre?.value}
                  onChange={(e) => handleChange(e)}
                  disabled={isPreview}
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />
                <label for={pre?.id} class="radio-inline custom-control-label">
                  {pre?.label}
                </label>
              </div>
            ))
          : null
        : (premiums ?? []).map((pre) => (
            <div class="custom-control custom-radio custom-control-inline mt-1">
              {console.log("types--", data[pre?.name])}
              <input
                type={pre?.type}
                name={pre?.name}
                id={pre?.id}
                class="custom-control-input"
                value={pre?.value}
                checked={data[pre?.name] === pre?.value}
                onChange={(e) => handleChange(e)}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
              <label for={pre?.id} class="radio-inline custom-control-label">
                {pre?.label}
              </label>
            </div>
          ))}
      {/*Braska withdrawl fields*/}
      {data["premiumType"] === "W" && (
        <div className={isPreview ? "mt-2 pe-none" : "mt-2"}>
          {customerId!==ILS_CONSTS.ID && 
          <>
          <strong>
          <Text id="premium.option1des" />
          </strong>
          <p><Text id="premium.option1title" /></p>
          </>
          }
          {NeBraskaWithdrawl_Fields.filter((flds)=>listOfFields.some((i)=>i===flds.id))
          .map((f) => (
            <div class="col-md-12 mt-1">
              <label for={f.id} class="control-label">
                {f.label}*
              </label>
              <input
                type="text"
                class={!data[f.name] ? "error-input" : "form-control"}
                name={f.name}
                id={f.id}
                value={data[f.name]}
                maxLength={f.len}
                onChange={(event)=>{
                  if (
                    event.target.value !== "" &&
                    event.target.name ==="bankName" &&
                    !DataValidation.test(event.target.value)
                  ) {
                    return;
                  }
                  handleChange(event)}}
                disabled={isPreview}
                autoComplete="off"
                spellcheck="false"
                aria-autocomplete="both"
                aria-haspopup="false"
              />
              {f.text && <div>{f.text}</div>}
            </div>
          ))}
          <fieldset class="radio radio-tab mt-1 ml-2">
            <legend>
            <Text id="premium.bankaccounttype" /><strong class="mandatory-field-bold">*</strong>
            </legend>
            {NeBraska_AccType.map((f1) => (
              <div class="custom-control custom-radio custom-control-inline">
                {console.log("pent-", data[f1.name])}
                <input
                  type="radio"
                  className={
                    (!data[f1.name] && "error-input") + " custom-control-input"
                  }
                  name={f1.name}
                  id={f1.id}
                  value={f1.value}
                  onChange={(e) => handleChange(e)}
                  checked={data[f1.name] === f1.value ? true : false}
                />
                <label for={f1.id} class="radio-inline custom-control-label">
                  {f1.label}
                </label>
              </div>
            ))}
          </fieldset>
        </div>
      )}
    </>
  );
};
export default NeBraskaPremiums;
